import { render, staticRenderFns } from "./InfoButtonIcon.vue?vue&type=template&id=2a2ea146&scoped=true&"
import script from "./InfoButtonIcon.vue?vue&type=script&lang=js&"
export * from "./InfoButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./InfoButtonIcon.vue?vue&type=style&index=0&id=2a2ea146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ea146",
  null
  
)

export default component.exports